import { render, staticRenderFns } from "./addTeachGroup.vue?vue&type=template&id=216c60d2&"
import script from "./addTeachGroup.vue?vue&type=script&lang=js&"
export * from "./addTeachGroup.vue?vue&type=script&lang=js&"
import style0 from "./addTeachGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports